// extracted by mini-css-extract-plugin
export default {"badge":"BadgeHeader_badge__aKgHQ","badge__btn":"BadgeHeader_badge__btn__toCTP","badge__btn_child":"BadgeHeader_badge__btn_child__Zmv5R","betaBadge":"BadgeHeader_betaBadge__xJuIZ"};